import { useSearchParams } from "react-router-dom";
import { Clock, Phone, Info } from "lucide-react";
import SEO from "../components/SEO";
import PageHero from "../components/PageHero";
import EnquiryForm from "../components/EnquiryForm";
import { Reveal } from "../components/Reveal";
import { site } from "../config/site";

export default function BookPage() {
  const [params] = useSearchParams();
  const preselected = params.get("service") || "";

  return (
    <>
      <SEO
        title="Book an Appointment | Glow & Blow"
        description="Request an appointment at Glow & Blow Unisex Salon, Banjara Hills, Hyderabad. Appointment requests are subject to availability."
      />
      <PageHero
        eyebrow="Book / Enquire"
        titleLines={[
          <>Request an</>,
          <>
            <em className="italic text-champagne">Appointment</em>
          </>,
        ]}
        copy="Tell us when you'd like to visit and what you're looking for. We'll confirm your appointment directly."
      />

      <section className="pb-24 md:pb-32" data-testid="book-page">
        <div className="container-x grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal>
              <div className="border border-line bg-surface p-7 md:p-10">
                <EnquiryForm
                  key={preselected}
                  variant="booking"
                  preselectedService={preselected}
                />
              </div>
            </Reveal>
          </div>
          <div className="space-y-4 lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="border border-line bg-surface p-7">
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center border border-line text-champagne">
                    <Clock className="h-5 w-5" />
                  </span>
                  <h2 className="font-display text-xl font-medium text-ink">
                    Opening Hours
                  </h2>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-soften">
                  {site.hoursDays}
                  <br />
                  {site.hoursTime}
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="grain-dark bg-ink p-7 text-ivory">
                <div className="flex items-center gap-4">
                  <span className="flex h-12 w-12 items-center justify-center border border-white/15 text-champagne">
                    <Phone className="h-5 w-5" />
                  </span>
                  <h2 className="font-display text-xl font-medium">
                    Prefer to Talk?
                  </h2>
                </div>
                <p className="mt-4 text-sm leading-relaxed text-ivory/70">
                  Call or WhatsApp us and we'll help you find a time that works.
                </p>
                <a
                  href={site.phoneHref}
                  data-testid="book-call-btn"
                  className="mt-5 inline-flex min-h-[48px] items-center border border-champagne px-6 text-[13px] font-semibold uppercase tracking-[0.14em] text-champagne transition-colors hover:bg-champagne hover:text-ink"
                >
                  {site.phoneDisplay}
                </a>
              </div>
            </Reveal>
            <Reveal delay={0.26}>
              <div
                className="flex items-start gap-3 border border-champagne/40 bg-champagne/10 p-4 text-sm text-taupe"
                data-testid="booking-availability-note"
              >
                <Info className="mt-0.5 h-4 w-4 shrink-0 text-champagne-dark" />
                Appointment requests are subject to availability. This is an
                enquiry, not a confirmed booking — we'll confirm your slot
                directly.
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
